<template>
  <div>
    <StockOrderViewModal />
    <CancelStockOrderModal />
    <UnlockStockOrderModal />
  </div>
</template>
<script>
import StockOrderViewModal from "@/components/widgets/Modals/StockOrderViewModal";
import CancelStockOrderModal from "@/components/widgets/Modals/CancelStockOrderModal";
import UnlockStockOrderModal from "@/components/widgets/Modals/UnlockStockOrderModal";
export default {
  name: "StockOrdersActions",
  components: {
    StockOrderViewModal,
    CancelStockOrderModal,
    UnlockStockOrderModal
  }
};
</script>